import PropTypes from "prop-types";
import React, { createContext } from "react";

import getContexts from "./getContexts";

/**
 * ContextVisualProvider provides a function `getContexts` which traverses the React FiberNode tree to find all
 * context providers and their values, to pass along to a developer tool to visualize context values.
 */

export const ContextVisualContext = createContext(null);
export const ContextVisualProvider = ({ children }) => (
  <ContextVisualContext.Provider value={{ getContexts: () => getContexts(children) }}>
    {children}
  </ContextVisualContext.Provider>
);

ContextVisualProvider.displayName = "ContextVisualProvider";
ContextVisualProvider.propTypes = {
  /** Content that will be rendered. */
  children: PropTypes.node.isRequired,
};
